module.exports = __webpack_public_path__ + "img/exhibeetion.c102f8a4.png";